/* eslint-disable new-cap */
/* eslint-disable no-unused-vars */
import classNames from 'classnames'
import { Field, Formik, getIn } from 'formik'
import PropTypes from 'prop-types'
import React, { useEffect, useState, useRef } from 'react'
import ReactDOM from 'react-dom'
import { connect } from 'react-redux'
import { NavLink } from 'react-router-dom'
import { bindActionCreators } from 'redux'
import withImmutablePropsToJS from 'with-immutable-props-to-js'
import isEqual from 'react-fast-compare'
import merge from 'deepmerge'

import { deleteModel, exportData, fetchMany, toggleWideSidebar } from '../../actions'
import ReportEditSidebar from '../../containers/ReportEditSidebar'
import ReportScheduleSidebar from '../../containers/ReportScheduleSidebar'
import ChallengeModal from '../common/modals/ChallengeModal'
import { CONFIG, MINUSER, MODELROUTE, UI, CURRENCY } from '../../selectors'
import { sortBy, uniqueArray, updateSearchParms, useCustomCompareMemo, hasPermission } from '../../utils'
import Card from '../common/Card'
import CustomForm from '../common/forms/CustomForm'
import InlineSelect from '../common/forms/inputs/InlineSelect'
import TextInput from '../common/forms/inputs/Text'
import ModelActions from '../common/ModelActions'
import QueryBuilder from '../common/QueryBuilder'
import SimpleTable from '../common/simpletable/SimpleTable'
import { Button } from '../ui/Button'
import WideSidebar from '../ui/sidebar/WideSidebar'


const fetchTemplates = ({ actions, modelname, params }) => {
  new Promise((resolve, reject) => {
    const values = {
      modelname: 'templates',
      params: {
        model__in: [ modelname ],
        template_type: 'report',
        meta_fields: [ ],
        get_all: 1,
        ...params
      }
    }
    return actions.fetchMany({ values, resolve, reject })
  }).then(r => {
    actions.setTemplates(r.options)
  })
}

const fetchReports = ({ actions, modelname, params }) => {
  new Promise((resolve, reject) => {
    const values = {
      modelname: 'reports',
      params: {
        template__model__in: [ modelname ],
        template_type: 'report',
        meta_fields: [ 'category', 'template' ],
        get_all: 1,
        ...params
      }
    }
    return actions.fetchMany({ values, resolve, reject })
  }).then(r => {
    const reports = { none: [] }
    r.options.map(o => {
      let cat = getIn(o, 'category')
      if (!cat || cat.slug === '') {
        cat = { slug: 'none' }
      }
      if (!getIn(reports, cat.slug)) {
        reports[cat.slug] = []
      }
      reports[cat.slug].push(o)
      return cat
    })
    fetchTemplates({ actions, modelname, params })
    actions.setSearch(params)
    actions.setReports(reports)
  })
}


const fetchCategories = ({ actions, modelname, params }) => {
  new Promise((resolve, reject) => {
    const values = {
      modelname: 'templatecategories',
      params: {
        website_templates__template__model: modelname,
        website_templates__template__template_type: 'report',
        get_all: 1,
        ...params
      }
    }
    return actions.fetchMany({ values, resolve, reject })
  }).then(r => {
    actions.setCategories([ {
      slug: 'all',
      name: 'All'
    }, ...sortBy(r.options, 'slug') ])
  })
}

const ReportList = props => {
  const { match, config, reports_config, location, user, actions, ui, currency } = props
  const qs = new QueryBuilder(location.search)
  const [ reports, setReports ] = useState({})
  const [ categories, setCategories ] = useState([])
  const [ category, setCategory ] = useState(match.params.tab)
  const [ search, setSearch ] = useState(qs.getAllArgs(false))
  const [ templates, setTemplates ] = useState()
  const [ editTemplate, setEditTemplate ] = useState()
  const [ editSchedule, setEditSchedule ] = useState()
  const [ deleting, setDeleting ] = useState()
  const root = useRef(document.getElementById('wrapper'))
  let permissionKey, permissionKeyDelete, permissionKeyDeleteOwn, permissionKeyUpdate,
    permissionKeyUpdateOwn, permissionKeyView, permissionKeyViewOwn

  if ([ 'residential', 'commercial' ].includes(config.modelname)) {
    permissionKey = [ `listings_${config.modelname}_for_sale_reports_add`, `listings_${config.modelname}_to_let_reports_add` ]
    permissionKeyView = [ `listings_${config.modelname}_for_sale_reports_view`, `listings_${config.modelname}_to_let_reports_view` ]
    permissionKeyUpdate = [ `listings_${config.modelname}_for_sale_reports_update`, `listings_${config.modelname}_to_let_reports_update` ]
    permissionKeyDelete = [ `listings_${config.modelname}_for_sale_reports_delete`, `listings_${config.modelname}_to_let_reports_delete` ]
    permissionKeyViewOwn = [ `listings_${config.modelname}_for_sale_reports_view_own`, `listings_${config.modelname}_to_let_reports_view_own` ]
    permissionKeyUpdateOwn = [ `listings_${config.modelname}_for_sale_reports_update_own`, `listings_${config.modelname}_to_let_reports_update_own` ]
    permissionKeyDeleteOwn = [ `listings_${config.modelname}_for_sale_reports_delete_own`, `listings_${config.modelname}_to_let_reports_delete_own` ]
  } else {
    permissionKey = [ `${config.modelname === 'agents' ? 'users' : config.modelname}_reports_add` ]
    permissionKeyView = [ `${config.modelname === 'agents' ? 'users' : config.modelname}_reports_view` ]
    permissionKeyUpdate = [ `${config.modelname === 'agents' ? 'users' : config.modelname}_reports_update` ]
    permissionKeyDelete = [ `${config.modelname === 'agents' ? 'users' : config.modelname}_reports_delete` ]
    permissionKeyViewOwn = [ `${config.modelname === 'agents' ? 'users' : config.modelname}_reports_view_own` ]
    permissionKeyUpdateOwn = [ `${config.modelname === 'agents' ? 'users' : config.modelname}_reports_update_own` ]
    permissionKeyDeleteOwn = [ `${config.modelname === 'agents' ? 'users' : config.modelname}_reports_delete_own` ]
  }

  const can_add_perm = (
    hasPermission(permissionKey, user.permissions) ||
    hasPermission([ 'is_prop_data_user' ], user.permissions)
  )

  const archiveReport = report_id => {
    // eslint-disable-next-line no-new
    new Promise((resolve, reject) => actions.deleteModel({
      values: {
        selected: [ report_id ],
        modelname: 'reports'
      },
      resolve,
      reject
    })).catch(e => {
      console.error(e)
      setDeleting(null)
    }).finally(() => {
      const uqs = new QueryBuilder(location.search)
      fetchReports({
        actions: {
          fetchMany: actions.fetchMany,
          setCategories,
          setReports,
          setSearch,
          setTemplates
        },
        modelname: config.servicename,
        params: uqs.getAllArgs(false)
      })
      setDeleting(null)
    })
  }

  useEffect(() => {
    fetchCategories({
      actions: {
        fetchMany: actions.fetchMany,
        setCategories,
        setReports,
        setSearch
      },
      modelname: config.servicename
    })
    root.current = document.getElementById('wrapper')
  }, [])
  useEffect(() => {
    const uqs = new QueryBuilder(location.search)
    fetchReports({
      actions: {
        fetchMany: actions.fetchMany,
        setCategories,
        setReports,
        setSearch,
        setTemplates
      },
      modelname: config.servicename,
      params: uqs.getAllArgs(false)
    })
  }, [ category, config.servicename, location.search ])


  useEffect(() => {
    if (editTemplate?.id) {
      actions.toggleWideSidebar('show-report-edit')
    } else {
      const uqs = new QueryBuilder(location.search)
      fetchCategories({
        actions: {
          fetchMany: actions.fetchMany,
          setCategories,
          setReports,
          setSearch
        },
        modelname: config.servicename
      })
      fetchReports({
        actions: {
          fetchMany: actions.fetchMany,
          setCategories,
          setReports,
          setSearch,
          setTemplates
        },
        modelname: config.servicename,
        params: uqs.getAllArgs(false)
      })
    }
  }, [ useCustomCompareMemo(editTemplate) ])


  useEffect(() => {
    if (editSchedule?.id) {
      actions.toggleWideSidebar('show-schedule-edit')
    } else {
      const uqs = new QueryBuilder(location.search)
      fetchCategories({
        actions: {
          fetchMany: actions.fetchMany,
          setCategories,
          setReports,
          setSearch
        },
        modelname: config.servicename
      })
      fetchReports({
        actions: {
          fetchMany: actions.fetchMany,
          setCategories,
          setReports,
          setSearch,
          setTemplates
        },
        modelname: config.servicename,
        params: uqs.getAllArgs(false)
      })
    }
  }, [ useCustomCompareMemo(editSchedule) ])

  const report_table = useRef()

  if (!categories.length) {
    return null
  }
  return (
    <>
      <Formik
        initialValues={{
          ...search
        }}
        enableReinitialize={true}
        onSubmit={(values, form) => {
          updateSearchParms('term', values.term)
          form.setTouched({})
          form.setSubmitting(false)
        }}
      >{formik => (
          <div className="content">
            <div className="viewhead details">
              <div className="action-bar">
                <ModelActions
                  touched={formik.touched}
                  errors={formik.errors}
                  handleSubmit={e => {
                    e.preventDefault()
                  }}
                  actions={{
                    toggleSidebar: () => {
                      actions.toggleWideSidebar('show-report-edit')
                    }
                  }}
                  isSubmitting={formik.isSubmitting}
                  form={formik}
                  extras={{
                    ...(can_add_perm && {
                      addreport: {
                        label: 'Add Report',
                        menu: null,
                        redirect: null,
                        icon: '#icon16-Plus',
                        action: 'toggleSidebar',
                        className: 'btn-round btn-red'
                      }
                    }),
                    generatereport: {
                      label: 'Generate Report',
                      menu: null,
                      redirect: null,
                      icon: '#icon16-Plus',
                      action: 'toggleSidebar',
                      className: 'btn-round btn-red'
                    }
                  }}
                  modelname={config.modelname}
                  statusmsg={formik.status ? formik.status.msg : false}
                />


              </div>
            </div>
            <div className='view container-fluid'>
              <div className='viewcontent'>
                <div>
                  <Card
                    header={null}
                    background
                    body={
                      <>
                        <div className="templates-search">
                          <CustomForm
                            component="div"
                            render={el => (
                              <div className="search-fields">
                                <div className="input-group">
                                  <div className="field col-lg-4">
                                    <Field
                                      id="report-search"
                                      name="term"
                                      placeholder="Keyword Search"
                                      component={TextInput}
                                      className="term"
                                      bounce={true}
                                      show_search
                                      form_el={el}
                                      suffix={<Button icon="#icon24-Search" type="button" disabled={formik.isSubmitting} onClick={formik.submitForm} className="input-group-addon btn btn-icon-16 btn-icon-left btn-none" />}
                                    />
                                  </div>
                                  <div className="field col-lg-4">
                                    <InlineSelect
                                      id='report-category'
                                      name='category__slug'
                                      prefix={<div className="input-group-addon">Category</div>}
                                      className="inline-select meta-status"
                                      classNamePrefix="inline"
                                      autosize={true}
                                      search={search}
                                      onChange={e => {
                                        if (e.value === 'all') {
                                          updateSearchParms('category__slug', null)
                                        } else {
                                          updateSearchParms('category__slug', e.value)
                                        }
                                      }}
                                      noclear
                                      form={{
                                        setFieldError: async () => {},
                                        setFieldTouched: async () => {},
                                        setFieldValue: async () => {}
                                      }}
                                      field={{
                                        value: search.category__slug || 'all'
                                      }}
                                      selectedValue={search.category__slug || 'all'}
                                      options={categories.map(o => ({
                                        value: o.slug,
                                        label: o.name
                                      }))}
                                    />
                                  </div>
                                </div>
                                {search.term ? (
                                  <div className="reset-group">
                                    <strong>This list is filtered</strong>
                                    <Button
                                      id="keyword-search-btn"
                                      tabIndex="-1"
                                      type="button"
                                      icon="#icon16-Refresh"
                                      onClick={() => {
                                        formik.resetForm({ values: {} })
                                        formik.submitForm()
                                      }}
                                      disabled={formik.isSubmitting}
                                      className="input-group-addon btn btn-grey btn-icon-16 btn-icon-left"
                                    >
                                      Reset
                                    </Button>
                                  </div>
                                ) : null }
                              </div>
                            )}
                          />
                        </div>
                      </>
                    }
                  />
                  {
                    categories.map(cat => {
                      if (search.category__slug && search.category__slug !== cat.slug) {
                        return null
                      }
                      const cat_templates = getIn(reports, cat.slug === 'all' ? 'none' : cat.slug, [])
                      let fields = cat_templates.map(t => t.fields)
                        .reduce((prevList, nextList) => prevList.concat(nextList), [])
                      fields = fields.filter(t => t).map(t => {
                        const field = config.fields.find(f => isEqual(f.name, t.name))
                        return merge(field || {}, { ...t, colname: `${t.name}${t.verb ? `__${t.verb}` : ''}` })
                      })
                      fields = uniqueArray(fields, 'colname', true)
                      const cat_reports = cat_templates.flat(({ meta, ...temp }) => meta.reports ?.map(rep => ({
                        ...rep,
                        meta: {
                          ...rep.meta,
                          template: temp
                        }
                      }) || [])).reduce((prevList, nextList) => prevList.concat(nextList), [])
                      if (!cat_reports.length) {
                        return null
                      }
                      return (
                        <Card
                          key={`cat-${cat.slug}`}
                          header={(
                            <>
                              <h3>{cat.name}</h3>
                            </>
                          )}
                          background
                          body={
                            <div className="reportsbody">
                              <SimpleTable
                                user={user}
                                config={reports_config}
                                currency={currency}
                                header={[
                                  {
                                    label: 'Name',
                                    name: 'name',
                                    orderable: false
                                  },
                                  {
                                    label: 'Template',
                                    name: 'meta.template.display_name',
                                    orderable: false,
                                    orderby: 'template__name'
                                  },
                                  {
                                    label: 'Criteria',
                                    name: 'report_filters',
                                    multi: false,
                                    input: 'FieldArray',
                                    fields,
                                    format: 'criteria',
                                    orderable: false
                                  },
                                  {
                                    label: 'Created',
                                    name: 'created',
                                    format: 'datetime',
                                    orderable: false
                                  }
                                ]}
                                data={cat_reports}
                                match={match}
                                parser={response => {
                                  const data = {
                                    options: response
                                  }
                                  return data
                                }}
                                getClass={tbl => {
                                  report_table.current = tbl
                                }}
                                rowActions={(row, data) => {
                                  const can_view_perm = (
                                    hasPermission(permissionKeyView, user.permissions) ||
                                    hasPermission(permissionKeyViewOwn, user.permissions, data, user.agent.id, {
                                      agent: permissionKeyViewOwn
                                    }) ||
                                    hasPermission([ 'is_prop_data_user' ], user.permissions)
                                  )

                                  const can_update_perm = (
                                    hasPermission(permissionKeyUpdate, user.permissions) ||
                                    hasPermission(permissionKeyUpdateOwn, user.permissions, data, user.agent.id, {
                                      agent: permissionKeyUpdateOwn
                                    }) ||
                                    hasPermission([ 'is_prop_data_user' ], user.permissions)
                                  )

                                  const can_delete_perm = (
                                    hasPermission(permissionKeyDelete, user.permissions) ||
                                    hasPermission(permissionKeyDeleteOwn, user.permissions, data, user.agent.id, {
                                      agent: permissionKeyDeleteOwn
                                    }) ||
                                    hasPermission([ 'is_prop_data_user' ])
                                  )
                                  return (
                                    <>
                                      {(data.meta.template.name.includes('json') || data.meta.template.name === 'leads-analysis-report') ? (
                                        <Button icon="#icon16-EyeOpen" component={NavLink} className="btn btn-icon-16 btn-icon-only btn-none" to={`/secure/:site/${match.params.model}/reports/${data.meta.template.name.replace('.json', '').replace('/', ':')}/${data.id}`} title="View Report" type="button" />
                                      ) : (
                                        <>
                                          {can_update_perm ? (
                                            <Button icon="#icon16-Calendar" className="btn btn-icon-16 btn-icon-only btn-none" onClick={() => (editSchedule?.id === data.id ? setEditSchedule(null) : setEditSchedule(data))} title="Edit Schedule" type="button" />) : null}

                                          {can_view_perm ? (
                                            <Button icon="#icon16-Download" className="btn btn-icon-16 btn-icon-only btn-none" onClick={() => {
                                              new Promise((resolve, reject) => {
                                                const params = {
                                                  params: data.report_filters,
                                                  args: {
                                                    action: 'report',
                                                    template: data.meta.template.name
                                                  },
                                                  modelname: config.modelname,
                                                  label: data.name,
                                                  resolve,
                                                  reject
                                                }
                                                return actions.exportData(params)
                                              }).catch(e => {
                                                console.error(e)
                                              })
                                            }} title="Download Report" type="button" />) : null}

                                        </>
                                      )}
                                      {can_update_perm ? (
                                        <Button icon="#icon16-Edit" className="btn btn-icon-16 btn-icon-only btn-none" onClick={() => (editTemplate?.id === data.id ? setEditTemplate(null) : setEditTemplate(data))} title="Edit Report" type="button" />) : null}

                                      {(data.status !== 'Inactive' && can_delete_perm) ? (
                                        <Button icon="#icon16-Bin" className="btn btn-icon-16 btn-icon-only btn-none"onClick={() => setDeleting(data.id)} title="Archive Report" type="button" />
                                      ) : null}
                                    </>
                                  )
                                }}
                              />
                            </div>
                          }
                        />
                      )
                    })
                  }
                </div>
              </div>
            </div>
          </div>
        )}
      </Formik>
      <WideSidebar sidebar={'show-report-edit'}>
        <ReportEditSidebar
          modelname={config.servicename}
          templates={templates}
          report={editTemplate}
          sidebar={'show-report-edit'}
          setEditTemplate={setEditTemplate}
          onSave={() => {
            report_table.refreshPage()
          }}
          match={match}
          user={user}
        />
      </WideSidebar>
      <WideSidebar sidebar={'show-schedule-edit'}>
        <ReportScheduleSidebar
          modelname={config.servicename}
          templates={templates}
          report={editSchedule}
          sidebar={'show-schedule-edit'}
          setEditSchedule={setEditSchedule}
          user={user}
          match={match}
        />
      </WideSidebar>
      {(root.current && deleting) ? (
        ReactDOM.createPortal(
          <Formik
            initialValues={{
              record_id: [ deleting ]
            }}
            enableReinitialize={true}
            validateOnChange={false}
            validateOnBlur={true}
          >{ formik => (
              <ChallengeModal
                isLoading={ui?.isLoading}
                action={'deleteModels'}
                challenges={[
                  {
                    text: (
                      <span>
                              You&apos;re about to delete
                        <span> {formik.values.record_id.length.toString()} </span> report.
                              Please confirm your action by typing <code>CONFIRM</code> in the field below.
                      </span>
                    ),
                    value: () => 'CONFIRM',
                    action: 'deleteModels'
                  },
                  {
                    text: (
                      <span>
                              You&apos;re about to delete
                        <span> {formik.values.record_id.length.toString()} </span> report.
                              Please confirm your action by typing <code>DELETE</code> in the field below.
                      </span>
                    ),
                    value: () => 'DELETE',
                    action: 'deleteModels'
                  }
                ]}
                visible={deleting}
                buttons={(({ valid, value }) => (
                  <div className="modal-buttons">
                    <Button className={classNames('btn', 'btn-primary', { disabled: !valid })} type="submit" onClick={valid ? () => {
                      formik.setFieldTouched('challenge', true, false)
                      if (valid) {
                        archiveReport(deleting)
                      } else {
                        formik.setFieldError('challenge', value ? 'This field is invalid' : 'This field is required')
                      }
                    } : null}>Confirm</Button>
                    <Button className="btn btn-white" type="submit" onClick={() => {
                      setDeleting(null)
                    }}>Cancel</Button>
                  </div>
                ))}
              />
            )}
          </Formik>, root.current)
      ) : null }
    </>
  )
}

ReportList.propTypes = {
  location: PropTypes.object,
  config: PropTypes.object,
  reports_config: PropTypes.object,
  user: PropTypes.object,
  routeConfig: PropTypes.object,
  currency: PropTypes.string,
  match: PropTypes.object,
  sidebar: PropTypes.string,
  actions: PropTypes.object,
  ui: PropTypes.object
}

const mapStateToProps = (state, ownProps) => { // Pass only minimal data to the FieldGroup component
  const { model } = ownProps.match.params
  const user = MINUSER(state)
  const ui = UI(state)
  const config = CONFIG(state, model)
  const reports_config = CONFIG(state, 'reports')
  const routeConfig = MODELROUTE(state, model)
  const currency = CURRENCY(state)

  return {
    user,
    config,
    reports_config,
    routeConfig,
    ui,
    currency
  }
}

const mapDispachToProps = dispatch => ({
  actions: bindActionCreators({
    exportData,
    fetchMany,
    deleteModel,
    toggleWideSidebar
  }, dispatch)
})

export default connect(mapStateToProps, mapDispachToProps)(withImmutablePropsToJS(ReportList))

